// extracted by mini-css-extract-plugin
module.exports = {"container":"e_nj","imageContainer":"e_oj","image":"e_pj","imageInverted":"e_qj","postedInfo":"e_rj","socials":"e_sj","date":"e_tj"};